import { render, staticRenderFns } from "./Workload_Income_allocation.vue?vue&type=template&id=c423f8c2&style=true"
import script from "./Workload_Income_allocation.vue?vue&type=script&lang=js"
export * from "./Workload_Income_allocation.vue?vue&type=script&lang=js"
import style0 from "./Workload_Income_allocation.vue?vue&type=style&index=0&id=c423f8c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports